"use client";

import React from "react";
import { Skeleton } from "@/components/ui/adapters";

/** Skeleton for full-viewport doc pages (Terms, Policy) – mimics iframe document layout. */
export function DocPageSkeleton(): React.ReactElement {
  return (
    <div className="w-full h-dvh flex flex-col bg-background-light p-6 md:p-10 overflow-hidden">
      <div className="w-full max-w-3xl mx-auto space-y-3">
        <Skeleton className="h-10 w-3/4 rounded-xl bg-secondary-light/90" />
        <Skeleton className="h-4 w-full rounded-lg bg-secondary-light/80" />
        <Skeleton className="h-4 w-full rounded-lg bg-secondary-light/80" />
        <Skeleton className="h-4 w-5/6 rounded-lg bg-secondary-light/80" />
        <Skeleton className="h-8 w-48 mt-6 rounded-xl bg-secondary-light/90" />
        <Skeleton className="h-4 w-full rounded-lg bg-secondary-light/80" />
        <Skeleton className="h-4 w-full rounded-lg bg-secondary-light/80" />
        <Skeleton className="h-4 w-4/5 rounded-lg bg-secondary-light/80" />
        <Skeleton className="h-8 w-40 mt-6 rounded-xl bg-secondary-light/90" />
        <Skeleton className="h-4 w-full rounded-lg bg-secondary-light/80" />
        <Skeleton className="h-4 w-full rounded-lg bg-secondary-light/80" />
      </div>
    </div>
  );
}
